import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import {
  BookingFormFields,
  DirectionEnum,
  dropdownAtomFamily,
  ISelectListItemShiftTime,
  mergeDateWithHHmmTime,
  TTimeHHmm,
  useTimezone,
} from "@ryde/shared";

import { IHandleDirectionUpdate } from "./booking-edit.models";

export const useBookingEditInner = () => {
  const { getValues, setValue } = useFormContext();
  const { timezone } = useTimezone();

  const shiftDropDownItems = useRecoilValue(dropdownAtomFamily("shift"));

  const handleDirectionUpdate = useEvent(
    ({
      directionWatch,
      checkShiftAndChangeDirection = false,
    }: IHandleDirectionUpdate) => {
      if (
        directionWatch !== DirectionEnum.PickUp &&
        directionWatch !== DirectionEnum.DropOff
      ) {
        return;
      }

      const shiftId = getValues(BookingFormFields.shiftId);
      const shift = shiftDropDownItems.find(item => item.value === shiftId);

      if (!shift) {
        return;
      }

      if (checkShiftAndChangeDirection) {
        const isShiftHasStartTime = (shift as ISelectListItemShiftTime)
          ?.shiftStartTime;
        const isShiftHasEndTime = (shift as ISelectListItemShiftTime)
          ?.shiftEndTime;
        let isForceChangeDirection = null;

        if (directionWatch === DirectionEnum.PickUp && !isShiftHasStartTime) {
          if (isShiftHasEndTime) {
            isForceChangeDirection = DirectionEnum.DropOff;
          }
        } else if (
          directionWatch === DirectionEnum.DropOff &&
          !isShiftHasEndTime
        ) {
          if (isShiftHasStartTime) {
            isForceChangeDirection = DirectionEnum.PickUp;
          }
        }

        if (isForceChangeDirection) {
          setValue(BookingFormFields.direction, isForceChangeDirection);
          return;
        }
      }

      let resolvedShiftTime: TTimeHHmm | null | undefined = null;

      switch (directionWatch) {
        case DirectionEnum.PickUp:
          resolvedShiftTime = (shift as ISelectListItemShiftTime)
            ?.shiftStartTime;
          break;
        case DirectionEnum.DropOff:
          resolvedShiftTime = (shift as ISelectListItemShiftTime)?.shiftEndTime;
          break;
      }

      if (!resolvedShiftTime) {
        return;
      }

      const currentValue = getValues(BookingFormFields.bookTime) as TDateISO;

      if (!currentValue) {
        return;
      }

      setValue(
        BookingFormFields.bookTime,
        mergeDateWithHHmmTime(
          currentValue as TDateISO,
          resolvedShiftTime,
          timezone,
        ),
      );
    },
  );

  return { handleDirectionUpdate };
};
